export const FILTER_SHOWALL = -1;
export const FILTER_SHOWNONE = -2;
export const ID_COMPTALK = 1;
export const ID_ATTEST = 3;
export const ID_COURSESTATISTICS = 6;
export const ID_COMPETENCEMANAGEMENT = 7;
export const ID_REGISTERANDCANCEL = 8;
export const ID_SEARCHANDFILTER = 9;
export const ID_ENGAGE = 10;
export const ID_GOALSANDACTIVITIES = 11;

export const AVAILABLE_TEAM_FUNCTIONS_RIGHTS = [
  FILTER_SHOWALL,
  FILTER_SHOWNONE,
  ID_COMPTALK,
  ID_ATTEST,
  ID_COURSESTATISTICS,
  ID_COMPETENCEMANAGEMENT,
  ID_REGISTERANDCANCEL,
  ID_SEARCHANDFILTER,
  ID_ENGAGE,
  ID_GOALSANDACTIVITIES,
];

export const TEAM = "team";
export const UNIT = "unit";
